const Config = {
  "name": "1.0.2-semester1",
  "actions": {
    "Card01": {
      "displayName": "Read for Fun",
      "displayNameInShop": "Read for Fun",
      "image": "images/card/Read_For_Fun_16_9.png",
      "description": "I love reading : it makes me more attentive to the world and opportunities around me. ",
      "moneyCost": 0,
      "energyCost": 1,
      "producesGrowthMindset": 1,
      "producesMoney": 0,
      "producesAttention": 1,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card01"
    },
    "Card02": {
      "displayName": "Uncle Zhao's: Allowance",
      "displayNameInShop": "Uncle Zhao's: Extra Shift",
      "image": "images/card/Money_Bill_16_9.png",
      "description": "Uncle Zhao always lets me work at his restaurant for a few extra bucks.",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 1,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card02"
    },
    "Card03": {
      "displayName": "Meditation",
      "displayNameInShop": "Meditation",
      "image": "images/card/Meditation_16_9.png",
      "description": "Empty your mind of everything except Meditation. And Meditation.",
      "moneyCost": 2,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 8,
      "id": "Card03"
    },
    "Card04": {
      "displayName": "Visit Library",
      "displayNameInShop": "NY Public Library Card",
      "image": "images/card/Library_16_9.png",
      "description": "Books take you to new worlds!",
      "moneyCost": 1,
      "energyCost": 1,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 3,
      "discardsCards": 1,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card04"
    },
    "Card05": {
      "displayName": "Overnight Studying",
      "displayNameInShop": "Overnight Studying",
      "image": "images/card/Overnight_Study_16_9.png",
      "description": "When you pull an all-nighter your mind gets stronger and you can do more. ",
      "moneyCost": 2,
      "energyCost": 0,
      "producesGrowthMindset": 1,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [
        "fatigue"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card05"
    },
    "Card06": {
      "displayName": "Healthy Cooking",
      "displayNameInShop": "Cookbook",
      "image": "images/card/Healthy_Food_16_9.png",
      "description": "Cooking with quality ingredients nourishes you and gives you way more energy.",
      "moneyCost": 3,
      "energyCost": 1,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 3,
      "producesStudyPoints": 0,
      "drawsCards": 2,
      "discardsCards": 2,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card06"
    },
    "Card07": {
      "displayName": "Abundant Thinking",
      "displayNameInShop": "Abundant Thinking",
      "image": "images/card/Abundant_Thinking_16_9.png",
      "description": "I see no limits; only possibilities. But, can too much of this be a bad thing? ",
      "moneyCost": 2,
      "energyCost": 1,
      "producesGrowthMindset": 1,
      "producesMoney": 1,
      "producesAttention": 1,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [
        "Card07"
      ],
      "forgetsOnDiscard": true,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card07"
    },
    "Card08": {
      "displayName": "Impressive Jacket",
      "displayNameInShop": "Impressive Jacket",
      "image": "images/card/Jacket_16_9.png",
      "description": "This jacket makes you look mature. You feel energized and excited about the future.",
      "moneyCost": 4,
      "energyCost": 0,
      "producesGrowthMindset": 1,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 2,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card08"
    },
    "Card09": {
      "displayName": "Subway Musician",
      "displayNameInShop": "Learn a Song",
      "image": "images/card/Music_16_9.png",
      "description": "Tips are hard to come by, but New Yorkers like their music. Hardly feels like work. ",
      "moneyCost": 2,
      "energyCost": 2,
      "producesGrowthMindset": 0,
      "producesMoney": 2,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card09"
    },
    "Card10": {
      "displayName": "Sugar Rush",
      "displayNameInShop": "Energy Drink",
      "image": "images/card/Sugar_Rush_16_9.png",
      "description": "Pure sugar... flowing through my veins...",
      "moneyCost": 5,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 1,
      "producesEnergy": 4,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 1,
      "gainsCards": [
        "fatigue"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card10"
    },
    "Card11": {
      "displayName": "S.M.A.R.T Goals",
      "displayNameInShop": "S.M.A.R.T Goals",
      "image": "images/card/Smart_Goal_16_9.png",
      "description": "I don't always make goals, but when I do, they are specific, measurable, attainable, relevant, and time-based.",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 2,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card11"
    },
    "Card12": {
      "displayName": "Sell Sneakers",
      "displayNameInShop": "Start an online shoe LLC",
      "image": "images/card/Sneaker_16_9.png",
      "description": "As a high school CEO of a 1-person online resale business and you have to prioritize your time.",
      "moneyCost": 6,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 4,
      "producesAttention": 2,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 1,
      "id": "Card12"
    },
    "fatigue": {
      "displayName": "Fatigue",
      "displayNameInShop": "Fatigue",
      "image": "images/card/Fatigue_16_9.png",
      "description": "Better rest up or I'll just get even more tired later.",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "fatigue"
    },
    "summerHomework": {
      "displayName": "Summer Homework",
      "displayNameInShop": "Summer Homework",
      "image": "images/card/Homework_16_9.png",
      "description": "So tedious...",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 1,
      "producesMoney": 0,
      "producesAttention": 1,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": true,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "summerHomework"
    },
    "Card15": {
      "displayName": "Bargain Hunting",
      "displayNameInShop": "Bargain Hunting",
      "image": "images/card/Shopping_16_9.png",
      "description": "A good eye helps me see deals others might miss.",
      "moneyCost": 3,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 1,
      "producesAttention": 1,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 3,
      "discardsCards": 3,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card15"
    },
    "Card16": {
      "displayName": "Haunting Memory",
      "displayNameInShop": "Haunting Memory",
      "image": "images/card/Haunted_Memory_16_9.png",
      "description": "Haunting memories of past mistakes & failures. But will they make you stronger ? ",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 2,
      "discardsCards": 0,
      "gainsCards": [
        "fatigue"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 1,
      "id": "Card16"
    },
    "Card17": {
      "displayName": "Ascend to Olympus",
      "displayNameInShop": "Ascend to Olympus",
      "image": "images/card/Olympus_16_9.png",
      "description": "There are truly no limits to my potential as long as I work hard.",
      "moneyCost": 9,
      "energyCost": 0,
      "producesGrowthMindset": 1,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 2,
      "producesStudyPoints": 0,
      "drawsCards": 5,
      "discardsCards": 3,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card17"
    },
    "Card18": {
      "displayName": "Red Packet",
      "displayNameInShop": "Red Packet",
      "image": "images/card/Red_Packet_16_9.png",
      "description": "Too bad Chinese New Year only comes once a year.",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 5,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card18"
    },
    "Card19": {
      "displayName": "Music Club",
      "displayNameInShop": "Music Club",
      "image": "images/card/Music_Club_16_9.png",
      "description": "I love jamming in the school music club, but goodbye afternoons!",
      "moneyCost": 4,
      "energyCost": 1,
      "producesGrowthMindset": 3,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 2,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card19"
    },
    "Card20": {
      "displayName": "Counseling",
      "displayNameInShop": "Counseling",
      "image": "images/card/Therapist_16_9.png",
      "description": "I'm in a tough spot, but I have the courage to ask for help.",
      "moneyCost": 5,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [
        "Card03",
        "Card03"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card20"
    },
    "Card21": {
      "displayName": "Procastination",
      "displayNameInShop": "Procastination",
      "image": "images/card/Procrastination_16_9.png",
      "description": "\"I'll do this later\"",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 2,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card21"
    },
    "Card22": {
      "displayName": "Lazy",
      "displayNameInShop": "Lazy",
      "image": null,
      "description": "You've been grinding hard. You're tempted to be lazy...",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card22"
    },
    "Card23": {
      "displayName": "Daily Practice",
      "displayNameInShop": "Music Book",
      "image": "images/card/Music_Practice_16_9.png",
      "description": "If you really want to improve, make sure to practice every day!",
      "moneyCost": 4,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": true,
      "forgetsSelf": false,
      "forgetsCards": 1,
      "id": "Card23"
    },
    "Card24": {
      "displayName": "Make Memories",
      "displayNameInShop": "Make Memories",
      "image": "images/card/Make_Memory_16_9.png",
      "description": "Some memories last a lifetime.",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 1,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 3,
      "producesStudyPoints": 0,
      "drawsCards": 3,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card24"
    },
    "Card25": {
      "displayName": "Mentoring Workshop",
      "displayNameInShop": "Join Mentoring Program",
      "image": "images/card/Apex_16_9.png",
      "description": "Ah, a friend! A little late though. Ah well. ",
      "moneyCost": 1,
      "energyCost": 3,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [
        "Card11",
        "Card37"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card25"
    },
    "Card26": {
      "displayName": "Rich Cousins",
      "displayNameInShop": "Rich Cousins",
      "image": "images/card/Cousin_16_9.png",
      "description": "They like to rub their \"success\" in your face with lavish gifts.",
      "moneyCost": 4,
      "energyCost": 4,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 2,
      "gainsCards": [
        "Card18"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card26"
    },
    "Card27": {
      "displayName": "Learn to Swim",
      "displayNameInShop": "Swim Lessons",
      "image": "images/card/Swimming_16_9.png",
      "description": "I have to learn to swim for our Spring Trip!",
      "moneyCost": 0,
      "energyCost": 3,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [
        "Card39"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card27"
    },
    "Card28": {
      "displayName": "Study: Creative Writing",
      "displayNameInShop": "Study: Creative Writing",
      "image": "images/card/Study__Creative_Writing_16_9.png",
      "description": "Gives Study Points.",
      "moneyCost": 2,
      "energyCost": 2,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 1,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card28"
    },
    "Card29": {
      "displayName": "Study: Study w/ New PC ",
      "displayNameInShop": "Study: New PC",
      "image": "images/card/Study__Online_Lecture_16_9.png",
      "description": "A new laptop helps me to study and finish assignments more efficiently. ",
      "moneyCost": 6,
      "energyCost": 2,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 2,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card29"
    },
    "Card30": {
      "displayName": "Study: Practice Math",
      "displayNameInShop": "Study: Practice Math",
      "image": "images/card/Study__Math_16_9.png",
      "description": "Gives Study Points.",
      "moneyCost": 3,
      "energyCost": 5,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 2,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card30"
    },
    "Card31": {
      "displayName": "Study: Science Lab",
      "displayNameInShop": "Study: Science Lab",
      "image": "images/card/Study__Science_16_9.png",
      "description": "Gives Study Points",
      "moneyCost": 4,
      "energyCost": 8,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 1,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [
        "fatigue"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card31"
    },
    "Card32": {
      "displayName": "Study: Read Textbook",
      "displayNameInShop": "Study: Read Textbook",
      "image": "images/card/Study__Textbook_16_9.png",
      "description": "Get study points.",
      "moneyCost": 10,
      "energyCost": 4,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 1,
      "drawsCards": 0,
      "discardsCards": 3,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card32"
    },
    "Card33": {
      "displayName": "Junk Food",
      "displayNameInShop": "Junk Food",
      "image": "images/card/Junk_Food_16_9.png",
      "description": "Delicious and efficient in the short-term. I probably should find better food in the long-term. ",
      "moneyCost": 2,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 2,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [
        "fatigue"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card33"
    },
    "Card34": {
      "displayName": "Lift Weights",
      "displayNameInShop": "Buy Dumbbells",
      "image": "images/card/Workout_16_9.png",
      "description": "Put in the time now to improve your body and do more in the future. ",
      "moneyCost": 1,
      "energyCost": 1,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 2,
      "gainsCards": [
        "Card35"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card34"
    },
    "Card35": {
      "displayName": "Burst of Energy",
      "displayNameInShop": "Burst of Energy",
      "image": "images/card/Burst_Of_Energy_16_9.png",
      "description": "Your consistent exercise is really paying off. Your body has more energy than it used to. ",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 2,
      "producesStudyPoints": 0,
      "drawsCards": 2,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": true,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card35"
    },
    "Card36": {
      "displayName": "Soccer With Friends",
      "displayNameInShop": "New Soccer Ball",
      "image": "images/card/After_School_Club_16_9.png",
      "description": "Video games are fun, but playing soccer always gives me extra energy. ",
      "moneyCost": 1,
      "energyCost": 0,
      "producesGrowthMindset": 1,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 1,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card36"
    },
    "Card37": {
      "displayName": "Year-End Project",
      "displayNameInShop": "Year-End Project",
      "image": "images/card/Meta_16_9.png",
      "description": "We might have bitten off more than we could chew...",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 0,
      "gainsCards": [
        "Card11",
        "fatigue"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card37"
    },
    "Card39": {
      "displayName": "Join Swim Team",
      "displayNameInShop": "Join Swim Team",
      "image": "images/card/Swim_Laps_16_9.png",
      "description": "My teacher is also coach of the school swim team. ",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 2,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [
        "Card40"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card39"
    },
    "Card40": {
      "displayName": "Swim Practice",
      "displayNameInShop": "Swim Practice",
      "image": "images/card/Swim_Team_16_9.png",
      "description": "Practice is tiring, but I'm in the best shape of my life!",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 3,
      "producesStudyPoints": 0,
      "drawsCards": 1,
      "discardsCards": 0,
      "gainsCards": [
        "Card41"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": true,
      "forgetsCards": 0,
      "id": "Card40"
    },
    "Card41": {
      "displayName": "Cook Family Meal",
      "displayNameInShop": "Cook Family Meal",
      "image": "images/card/Healthy_Food_16_9.png",
      "description": "Now that Mom is so sick, the family needs me to cook.. oof. ",
      "moneyCost": 0,
      "energyCost": 0,
      "producesGrowthMindset": 0,
      "producesMoney": 0,
      "producesAttention": 0,
      "producesEnergy": 0,
      "producesStudyPoints": 0,
      "drawsCards": 0,
      "discardsCards": 1,
      "gainsCards": [
        "fatigue"
      ],
      "forgetsOnDiscard": false,
      "forgetsSelf": false,
      "forgetsCards": 0,
      "id": "Card41"
    }
  },
  "events": {
    "SummerStart": {
      "displayName": "Middle School Graduation",
      "image": "images/event/Middle_School_Graduation_3_2.png",
      "song": "songs/af.mp3",
      "description": "After a long year, you've finally graduated from middle school. This Summer Break you want to get more opportunities to grow your growth mindset. ",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 2,
      "indebtedTurns": 0,
      "energizedTurns": 2,
      "addsCardsToShop": [
        "Card36",
        "Card01",
        "Card02",
        "Card02"
      ],
      "addsCardsToDiscardPile": [
        "summerHomework",
        "summerHomework"
      ],
      "buttonLabel": "Continue",
      "id": "SummerStart"
    },
    "SchoolStart": {
      "displayName": "High School Begins",
      "image": "images/event/School_3_2.png",
      "song": "songs/da.mp3",
      "description": "High school is here and you NEED to ace your Creative Writing class. You're going to be busy but there are some amazing [opportunities|STUDY: CREATIVE WRITING] that can profoundly impact your future potential. ",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card06",
        "Card33",
        "Card28",
        "Card25"
      ],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "SchoolStart"
    },
    "Event3": {
      "displayName": "It's getting Cold",
      "image": "images/event/School_Cold_3_2.png",
      "song": "songs/da.mp3",
      "description": "The cold drains your energy. But, you want to get out more to [expand your world view|VISIT LIBRARY]. It would be wise to reflect on your busy life and [find clarity|MEDITATION] within yourself. ",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 1,
      "inspiredTurns": 0,
      "indebtedTurns": 1,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card04",
        "Card08",
        "Card09",
        "Card03"
      ],
      "addsCardsToDiscardPile": [
        "fatigue"
      ],
      "buttonLabel": "Continue",
      "id": "Event3"
    },
    "Event4": {
      "displayName": "Christmas Break!",
      "image": "images/event/Christmas_3_2.png",
      "song": "songs/af.mp3",
      "description": "Christmas Break ! You've gotten through the First Semester. You should explore older opportunities that may have passed you by. ",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 2,
      "indebtedTurns": 0,
      "energizedTurns": 2,
      "addsCardsToShop": [
        "Card07",
        "Card06"
      ],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event4"
    },
    "Event5": {
      "displayName": "Spring Break",
      "image": "images/event/Spring_Break_3_2.png",
      "song": null,
      "description": "<FLAVOR>",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 2,
      "indebtedTurns": 0,
      "energizedTurns": 2,
      "addsCardsToShop": [
        "Card12",
        "Card12"
      ],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event5"
    },
    "Event6": {
      "displayName": "Mom Falls Ill",
      "image": "images/event/Mom_Sick_3_2.png",
      "song": "songs/da.mp3",
      "description": "Mom's health took a somewhat serious decline. Doctors don't know when she'll be back and this makes my life pretty difficult.",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 2,
      "inspiredTurns": 0,
      "indebtedTurns": 2,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card20"
      ],
      "addsCardsToDiscardPile": [
        "Card21",
        "Card16",
        "fatigue",
        "Card22",
        "Card41",
        "Card41"
      ],
      "buttonLabel": "Continue",
      "id": "Event6"
    },
    "Event7": {
      "displayName": "Second Semester",
      "image": "images/event/Prepare_For_School_3_2.png",
      "song": null,
      "description": "Second semester has begun. Better keep up your studies ! ",
      "clearsShop": true,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card15",
        "Card29",
        "Card30"
      ],
      "addsCardsToDiscardPile": [
        "fatigue"
      ],
      "buttonLabel": "Continue",
      "id": "Event7"
    },
    "Event8": {
      "displayName": "Halfway through Summer Break ! ",
      "image": "images/event/Bedroom_3_2.png",
      "song": "songs/da.mp3",
      "description": "You promise to yourself that you want to get a headstart on Freshman year of High School. You want to do activities that help you be more productive. ",
      "clearsShop": true,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card02",
        "Card02",
        "Card34",
        "Card07",
        "Card05"
      ],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event8"
    },
    "Event9": {
      "displayName": "Dad's Business Struggling",
      "image": "images/event/Dad_Business_Struggle_3_2.png",
      "song": null,
      "description": "Dad hasn't been able to get the hours he usually gets at his job. I hope things turn around soon!",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 2,
      "inspiredTurns": 0,
      "indebtedTurns": 2,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card23"
      ],
      "addsCardsToDiscardPile": [
        "fatigue",
        "Card21",
        "Card16",
        "Card22"
      ],
      "buttonLabel": "Continue",
      "id": "Event9"
    },
    "Event10": {
      "displayName": "First Semester Finals",
      "image": "images/event/Exam_3_2.png",
      "song": null,
      "description": "This semester wasn't too bad. Make sure you've studied enough!",
      "clearsShop": false,
      "studyPointsThreshold": 1,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card03"
      ],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event10"
    },
    "Event11": {
      "displayName": "SAT WEEK",
      "image": "images/event/Exam_3_2.png",
      "song": null,
      "description": "<FLAVOR>",
      "clearsShop": false,
      "studyPointsThreshold": 3,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [
        "fatigue",
        "fatigue",
        "fatigue"
      ],
      "buttonLabel": "Continue",
      "id": "Event11"
    },
    "Event12": {
      "displayName": "FINAL EXAMS",
      "image": "images/event/Exam_3_2.png",
      "song": null,
      "description": "<FLAVOR>",
      "clearsShop": false,
      "studyPointsThreshold": 10,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event12"
    },
    "Event13": {
      "displayName": "It's getting Warmer",
      "image": "images/event/School_Warm_3_2.png",
      "song": null,
      "description": "Clubs are beginning to open up. Just in time, as there aren't many breaks here. ",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card26",
        "Card27",
        "Card19",
        "Card12",
        "Card12"
      ],
      "addsCardsToDiscardPile": [
        "Card18"
      ],
      "buttonLabel": "Continue",
      "id": "Event13"
    },
    "Event14": {
      "displayName": "Premonition",
      "image": "images/event/Premonition_3_2.png",
      "song": null,
      "description": "You hear the teacher say there is a test in 3 weeks and it's going to be hard. ",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card10"
      ],
      "addsCardsToDiscardPile": [
        "Card16",
        "Card22"
      ],
      "buttonLabel": "Continue",
      "id": "Event14"
    },
    "Event15": {
      "displayName": "Third Semester",
      "image": "images/event/Prepare_For_School_3_2.png",
      "song": null,
      "description": "<FLAVOR>",
      "clearsShop": true,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card32",
        "Card31",
        "Card17"
      ],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event15"
    },
    "Event16": {
      "displayName": "Spring Trip",
      "image": "images/event/NYC_Travel_3_2.png",
      "song": null,
      "description": "The class has organized a trip to Florida. This year is finally coming to an end!",
      "clearsShop": false,
      "studyPointsThreshold": 5,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [
        "Card24"
      ],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event16"
    },
    "Event17": {
      "displayName": "Premonition 2",
      "image": "images/event/Premonition_3_2.png",
      "song": null,
      "description": "Mom and Dad seem tense. Something's not right.",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event17"
    },
    "Event18": {
      "displayName": "Prom",
      "image": "images/event/Prom_3_2.png",
      "song": null,
      "description": "I like to move it; move it.",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Continue",
      "id": "Event18"
    },
    "fixed-mindset": {
      "displayName": "You Lose (Growth Mindset)!",
      "image": "images/event/You_Failed_3_2.png",
      "song": "songs/wgew.mp3",
      "description": "You lost that mental edge, that inner fire to help you overcome all of life's challenges and to grow stronger. ",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Play Again",
      "id": "fixed-mindset"
    },
    "failed-exam": {
      "displayName": "You Lose (Flunked Out of School)!",
      "image": "images/event/You_Failed_3_2.png",
      "song": "songs/wgew.mp3",
      "description": "Your academic health is critical to your overall growth and you've lost sight of that. ",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Play Again",
      "id": "failed-exam"
    },
    "win": {
      "displayName": "You Win!",
      "image": "images/event/You_Won_3_2.gif",
      "song": "songs/af.mp3",
      "description": "You got through high school!",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Play Again",
      "id": "win"
    },
    "actionLifecycle": {
      "displayName": "Action Lifecycle",
      "image": "images/event/Instructions_3_2.png",
      "song": null,
      "description": "",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Back to Game",
      "id": "actionLifecycle"
    },
    "begin-game": {
      "displayName": "Welcome to Unmuted: 2021!",
      "image": "images/event/Starting_Screen_3_2.png",
      "song": null,
      "description": "Unmuted: 2021 is a story about growing up in New York City as a first generation immigrant living in poverty.\n        While disadvantaged in many ways, you are determined to learn as much as you can as you start High School.\n        With an unshakeable Growth Mindset, you are confident that your hard work and your keen eye for opportunity will lead you to your dreams.\n        REMEMBER the sequence in which you perform actions each turn is very IMPORTANT.",
      "clearsShop": false,
      "studyPointsThreshold": 0,
      "engrossedTurns": 0,
      "inspiredTurns": 0,
      "indebtedTurns": 0,
      "energizedTurns": 0,
      "addsCardsToShop": [],
      "addsCardsToDiscardPile": [],
      "buttonLabel": "Begin Game",
      "id": "win"
    }
  },
  "schedule": {
    "0": [
      "SummerStart"
    ],
    "2": [
      "Event8"
    ],
    "3": [],
    "4": [],
    "5": [
      "SchoolStart"
    ],
    "6": [],
    "8": [
      "Event3"
    ],
    "11": [
      "Event14"
    ],
    "14": [],
    "15": [
      "Event10"
    ],
    "16": [
      "Event4"
    ],
    "17": [],
    "18": [
      "Event7"
    ],
    "19": [],
    "21": [
      "Event13"
    ],
    "22": [],
    "23": [
      "Event6"
    ],
    "24": [],
    "25": [],
    "28": [],
    "29": [
      "Event11"
    ],
    "30": [
      "Event5"
    ],
    "32": [
      "Event15"
    ],
    "34": [],
    "35": [
      "Event17"
    ],
    "36": [],
    "37": [
      "Event16"
    ],
    "38": [],
    "39": [],
    "40": [
      "Event9"
    ],
    "41": [],
    "43": [],
    "44": [
      "Event18"
    ],
    "45": [],
    "46": [],
    "47": [
      "Event12"
    ]
  },
  "specialEvents": {
    "fixedMindset": "fixed-mindset",
    "failedExam": "failed-exam",
    "win": "win",
    "actionLifecycle": "actionLifecycle",
    "beginGame": "begin-game"
  },
  "timestamp": 1620591190967
};

export default Config;
